import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

const ONBOARDING_EDIT_CHAT_MESSAGE = gql`
    mutation OnboardingEditChatMessage($request: EditMessageRequestDto!) {
        onboardingEditChatMessage(request: $request) {
            uuid
            candidateUuid
            senderName
            adminSender
            content
            modified
            editable
            createdAt
            adminReadAt
            candidateReadAt
        }
    }
`;

const useOnboardingEditChatMessage = () => {
    const [mutate, { loading, error }] = useMutation(ONBOARDING_EDIT_CHAT_MESSAGE);

    const editChatMessage = async (messageUuid, content) => {
        return mutate({
            variables: {
                request: {
                    messageUuid,
                    content,
                },
            },
        });
    };

    return {
        editChatMessage,
        loading,
        error,
    };
};

export default useOnboardingEditChatMessage;
